// extracted by mini-css-extract-plugin
module.exports = {"top-zoom-tools-wrapper":"styles_top-zoom-tools-wrapper__1VmRG","download-in-progress":"styles_download-in-progress__cnqT8","spin":"styles_spin__1K3h7"};